import React from 'react';
import ReactDOM from 'react-dom/client';  
import App from './App';
import './assets/scss/custom.scss';
import { Provider } from "react-redux";
import { store } from './Redux/baseApi/nftTicketBaseApi';

// const store = createStore(reducers, applyMiddleware(thunk))

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store= {store}>
      <App />
    </Provider>
  </React.StrictMode>
);